exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/stock/stock.component.css
// module id = ../../../../../src/app/pages/stock/stock.component.css
// module chunks = main